import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import { ItemImageAreaSkeleton, SkeletonText } from 'utoniq-ui'

export const OrderedItemBoxSkeleton = () => (
  <Card elevation={0}>
    <CardContent sx={{ p: 5 }}>
      <Stack spacing={4}>
        <Stack direction="row" spacing={4}>
          <ItemImageAreaSkeleton size="small" />
          <Stack flex={1} spacing={2}>
            <Stack>
              <SkeletonText variant="medium" width="100%" />
              <SkeletonText variant="medium" width="75%" />
            </Stack>
            <Stack>
              <SkeletonText variant="large" width="30%" />
              <SkeletonText variant="small" width="45%" />
            </Stack>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={4} alignItems="center">
          <Skeleton variant="circular" width={28} height={28} />
          <SkeletonText variant="small" width="40%" />
        </Stack>
      </Stack>
    </CardContent>
  </Card>
)
